<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <a-input-search v-model="query['no']" :placeholder="$t('placeholder.loadingOrderNo')" @pressEnter="search" @search="search" />
      <a-input-search v-model="query['dockNo']" :placeholder="$t('business.label.dock')" @pressEnter="search" @search="search" />
      <a-input-search v-model="query['vehicleNo']" :placeholder="$t('business.label.vehicleNo')" @pressEnter="search" @search="search" />
      <a-input-search v-model="query['driver']" :placeholder="$t('business.label.driver')" @pressEnter="search" @search="search" />
      <a-input-search v-model="query['driverPhone']" :placeholder="$t('business.label.phone')" @pressEnter="search" @search="search" />
      <a-date-picker v-model="query.dateFilter.start" :disabled-date="disabledStartDate" :placeholder="$t('placeholder.startTime')" show-today valueFormat="YYYY-MM-DD" />
      <a-date-picker v-model="query.dateFilter.end" :disabled-date="disabledEndDate" :placeholder="$t('placeholder.endTime')" show-today valueFormat="YYYY-MM-DD" />
      <vxe-button content="button.query" icon="vxe-icon-search" size="mini" status="primary" @click="search"/>
      <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="danger" @click="reset"/>
      <vxe-button content="button.expConfirm" size="mini" status="info" @click="exportExcel"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      :column-config="{resizable: true}"
      :row-config="{isCurrent: true, isHover: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      style="margin-top: 2px">
      <vxe-table-column fixed="left" sortable title="business.label.index" type="seq" width="40"/>
      <vxe-column field="order.invoiceTime" sortable title="business.label.invoiceTime" width="170"/>
      <vxe-column field="order.no" sortable title="business.label.loadingOrderNo" width="120"/>
      <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
      <vxe-column field="order.orderStatus" sortable title="business.label.orderStatus" width="100">
        <span slot-scope="{ row }">{{ orderStatusData.find(item => item.ordinal === row.order.orderStatus).name }}</span>
      </vxe-column>
      <vxe-column field="order.operator" sortable title="business.label.maker" width="100"/>
      <vxe-column field="order.deliverer" sortable title="business.label.deliver" width="100"/>
      <vxe-column field="issue.issuer" sortable title="business.label.issuer" width="100"/>
      <vxe-column field="issue.issueTime" sortable title="business.label.issueTime" width="170"/>
      <vxe-column field="dock.no" sortable title="business.label.dock" width="150"/>
      <vxe-column field="vehicle.no" sortable title="business.label.vehicleNo" width="150"/>
      <vxe-column field="order.driver" sortable title="business.label.driver" width="100"/>
      <vxe-column field="order.driverPhone" sortable title="business.label.phone" width="200"/>
      <vxe-column field="vehicle.type" sortable title="business.label.vehicleType" width="150"/>
      <vxe-column field="order.vehicleInPlaceStatus" sortable title="business.label.vehicleInPlaceStatus" width="150"/>
      <vxe-column field="order.departureTime" sortable title="business.label.departureTime" width="170"/>
      <vxe-column field="order.notes" sortable title="business.label.notes" width="150"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>
<script>
import { findAll, findEnum } from '@/api/Api'
import moment from 'moment'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'LoadingOrderQuery',
    data() {
      return {
        data: [],
        orderStatusData: [],
        storerData: [],
        loading: false,
        size: 20,
        page: 1,
        contentSize: 0,
        query: {
          'no': '',
          'dockNo': '',
          'vehicleNo': '',
          'driver': '',
          'driverPhone': '',
          dateFilter: {
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
          }
        },
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.815)// 表格竖向滚动条,减去的数值是页面其他元素的高度
      }
    },
    mounted() {
      findAll('storerFactory', { available: true }).then(res => {
        if (res.success) {
          this.storerData = res.result
        }
      })
      findEnum('OrderStatus').then(res => {
        if (res.success) {
          this.orderStatusData = res.result
        }
      })
    },
    methods: {
      moment,
      disabledStartDate(startValue) {
        const endValue = this.query.dateFilter.end
        if (!startValue || !endValue) {
          return false
        }
        return new Date(startValue) > new Date(endValue)
      },
      disabledEndDate(endValue) {
        const startValue = this.query.dateFilter.start
        if (!endValue || !startValue) {
          return false
        }
        return new Date(startValue) >= new Date(endValue)
      },
      pageChange({ currentPage, pageSize }) {
        this.page = currentPage
        this.size = pageSize
        this.getData()
      },
      getData() {
        this.loading = true
        const args = Object.assign({}, this.query)
        if (args.dateFilter.start === null && args.dateFilter.end === null) {
          args.dateFilter = null
        }
        findAll('loadingOrderFactory', args, this.page, this.size).then(res => {
          if (res.success) {
            this.contentSize = res.contentSize
            this.data = res.result
            setTimeout(() => {
              this.loading = false
            }, 300)
          } else {
            this.loading = false
          }
        })
      },
      search() {
        this.page = 1
        this.getData()
      },
      exportExcel() {
        this.$refs.table.openExport()
      },
      reset() {
        this.query = {
          'no': '',
          'dockNo': '',
          'vehicleNo': '',
          'driver': '',
          'driverPhone': '',
          dateFilter: {
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
          }
        }
        this.page = 1
        this.getData()
      }
    }
  }
</script>
<style scoped>
  .query {
    width: 180px;
  }
</style>